import { AppConfig } from '@luggagehero/shared/app-settings/data-access';
import { BookableStorageLocation } from '@luggagehero/shared/interfaces';

import { Address } from '../shops/address';
import { Capacity } from '../shops/capacity';
import { OpeningHours } from '../shops/opening-hours';

export function CreateManageableStorageLocation(): ManageableStorageLocation {
  return {
    name: '',
    address: new Address(),
    region: 'ww',
    openingHours: new OpeningHours(),
    capacity: {
      normal: 0,
      hand: 0,
    },
    minimumCapacity: {
      normal: AppConfig.DEFAULT_STORAGE_LOCATION_MIN_CAPACITY_NORMAL,
      hand: AppConfig.DEFAULT_STORAGE_LOCATION_MIN_CAPACITY_HAND,
    },
    maximumCapacity: {
      normal: AppConfig.DEFAULT_STORAGE_LOCATION_MAX_CAPACITY_NORMAL,
      hand: AppConfig.DEFAULT_STORAGE_LOCATION_MAX_CAPACITY_HAND,
    },
    location: { coordinates: [0, 0] },
    certified: false,
    wifiInfo: {},
    partnerLevel: 0,
    notifications: {
      bookingConfirmation: true,
      checkInConfirmation: true,
      checkOutConfirmation: true,
      onlinePaymentFailed: true,
      onlinePaymentSuccessful: true,
    },
    userId: '',
    email: '',
    billingEmail: '',
    contactEmail: '',
    sms: '',
    website: '',
    phone: '',
  } as ManageableStorageLocation;
}

// This is the full storage location object that can be controlled by storage managers
export interface ManageableStorageLocation extends BookableStorageLocation {
  userId: string;
  vatNumber?: string;
  primaryContact?: string;
  email: string;
  billingEmail: string;
  contactEmail: string;
  sms: string;
  website: string;
  phone: string;
  payoutCurrency?: string;
  securityTagFee?: number;
  splitStartupFee?: boolean;
  contractSigned?: boolean;
  minimumCapacity?: Capacity;
  maximumCapacity?: Capacity;
  maxCapacityForAdvanceBookings: number;
  place?: {
    id: string;
    name?: string;
  };
  stats?: {
    numberOfBookings?: number;
    numberOfWalkinBookings?: number;
    numberOfRatings?: number;
    numberOfPerfectRatings?: number;
    numberOfReviews?: number;
    averageRating?: number;
    averageSatisfaction?: number;
    averageNumberOfSundayBags?: number;
    numberOfUsersBooked?: number;
    numberOfUsersCheckedIn?: number;
    userCheckinRate?: number;
  };
  notifications?: {
    bookingConfirmation: boolean;
    checkInConfirmation: boolean;
    checkOutConfirmation: boolean;
    onlinePaymentSuccessful: boolean;
    onlinePaymentFailed: boolean;
  };
}
